import React from "react";

export default function InformacionCursoComprado({ cursoData }) {
  return (
    <>
      {cursoData.detail?.datos?.CURSO_INFORMACION?.que_aprenderas ? (
        <div className="apartado-1">
          <p className="apartado-1-texto">Lo que aprenderás</p>
          <div className="apartado-1-info">
            {cursoData.detail.datos.CURSO_INFORMACION.que_aprenderas.map(
              (item, index) => (
                <div key={index} className="apartado-lo-que-aprenderas">
                  <i className="fi fi-br-check" style={{ color: "white" }}></i>
                  <p className="apartado-lo-que-aprenderas-texto">{item}</p>
                </div>
              )
            )}
          </div>
        </div>
      ) : null}

      <div data-figma-id="1621:15813" className="informativo-curso-tablet">
        {cursoData.detail?.datos?.CURSO_INFORMACION?.modalidad ? (
          <div data-figma-id="2376:46197" class="informativo-curso-tablet-1">
            <i className="fi fi-rs-lesson signal-alt-2"></i>
            <div
              data-figma-id="1621:15814"
              className="informativo-curso-tablet-1-info"
            >
              <p
                data-figma-id="1621:15816"
                className="informativo-curso-tablet-1-texto-1"
              >
                Modalidad
              </p>
              <p
                data-figma-id="1621:15817"
                className="informativo-curso-tablet-1-texto-2"
              >
                {cursoData.detail.datos.CURSO_INFORMACION.modalidad}
              </p>
            </div>
          </div>
        ) : null}

        {cursoData.detail?.datos?.CURSO_INFORMACION?.nivel_aprendizaje ? (
          <div data-figma-id="2376:46197" class="informativo-curso-tablet-1">
            <i className="fi fi-ts-signal-alt signal-alt-2"></i>
            <div
              data-figma-id="1621:15818"
              className="informativo-curso-tablet-1-info"
            >
              <p
                data-figma-id="1621:15820"
                className="informativo-curso-tablet-1-texto-1"
              >
                Nivel de aprendizaje
              </p>
              <p
                data-figma-id="1621:15821"
                className="informativo-curso-tablet-1-texto-2"
              >
                {cursoData.detail.datos.CURSO_INFORMACION.nivel_aprendizaje}
              </p>
            </div>
          </div>
        ) : null}

        {cursoData.detail?.datos?.CURSO_INFORMACION?.duracion_total ? (
          <div data-figma-id="2376:46197" class="informativo-curso-tablet-1">
            <i className="fi fi-rr-clock-five signal-alt-2"></i>
            <div
              data-figma-id="1621:15822"
              className="informativo-curso-tablet-1-info"
            >
              <p
                data-figma-id="1621:15824"
                className="informativo-curso-tablet-1-texto-1"
              >
                Tiempo de duración
              </p>
              <p
                data-figma-id="1621:15825"
                className="informativo-curso-tablet-1-texto-2"
              >
                {cursoData.detail.datos.CURSO_INFORMACION.duracion_total}
              </p>
            </div>
          </div>
        ) : null}
        {cursoData.detail?.datos?.CURSO_INFORMACION?.idioma ? (
          <div data-figma-id="2376:46197" class="informativo-curso-tablet-1">
            <i className="fi fi-rs-language signal-alt-2"></i>
            <div
              data-figma-id="1621:15826"
              className="informativo-curso-tablet-1-info"
            >
              <p
                data-figma-id="1621:15828"
                className="informativo-curso-tablet-1-texto-1"
              >
                Idioma
              </p>
              <p
                data-figma-id="1621:15829"
                className="informativo-curso-tablet-1-texto-2"
              >
                {cursoData.detail.datos.CURSO_INFORMACION.idioma}
              </p>
            </div>
          </div>
        ) : null}
      </div>

      {cursoData.detail?.datos?.CURSO_INFORMACION?.descripcion ? (
        <>
          <div className="linea-curso-comrpadop-h"></div>
          <div data-figma-id="1621:15831" className="apartado-3">
            <p data-figma-id="1621:15832" className="apartado-3-texto-1">
              Descripción
            </p>
            <p data-figma-id="1621:15833" className="apartado-3-texto-2">
              {`¡Bienvenidos al curso ${cursoData.detail.datos.CURSO_INFORMACION.titulo}!`}
            </p>
            <p data-figma-id="1621:15834" className="apartado-3-texto-3">
              {cursoData.detail.datos.CURSO_INFORMACION.descripcion}
            </p>
          </div>
        </>
      ) : null}

      {cursoData.detail?.datos?.CURSO_INFORMACION?.requisitos ? (
        <>
          <div className="linea-curso-comrpadop-h"></div>
          <div data-figma-id="1621:15836" className="apartado-4">
            <p data-figma-id="1621:15837" className="apartado-4-texto">
              Requerimientos
            </p>
            <div data-figma-id="1621:15838" className="apartado-4-info">
              <ul>
                {cursoData.detail.datos.CURSO_INFORMACION.que_aprenderas.map(
                  (item, index) => (
                    <li key={index} className="apartado-4-info-1-texto">
                      {item}
                    </li>
                  )
                )}
              </ul>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
}
